export default "__VITE_ASSET__VT9LUdf___"